import { render, staticRenderFns } from "./TrainingManagement.vue?vue&type=template&id=aadb0782&scoped=true"
import script from "./TrainingManagement.vue?vue&type=script&lang=js"
export * from "./TrainingManagement.vue?vue&type=script&lang=js"
import style0 from "./TrainingManagement.vue?vue&type=style&index=0&id=aadb0782&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadb0782",
  null
  
)

export default component.exports